type Config = {
	Name: string;
	Description: string;
	Url: string;
	Email?: string;
	Phone?: string;
	ShowNewsletter?: boolean;
	Socials: {
		Twitter?: string;
		Github?: string;
		Linkedin?: string;
		Instagram?: string;
	};
	Header: {
		Links: { name: string; href: string }[];
	};
	ContactForm: {
		From: string;
		To: string;
	};
};

export const config: Config = {
	Name: "Francis Baker",
	Description:
		"Software engineer specializing in email infrastructure, deliverability, and developer tooling. Based in Massachusetts.",
	Url: "https://francispbaker.com",
	Email: "contact@francispbaker.com",
	Phone: "+1 (617) 800-0000",
	ShowNewsletter: false,
	Socials: {
		Twitter: "https://twitter.com/frncsbkr",
		Github: "https://github.com/baker",
		Linkedin: "https://linkedin.com/in/francispbaker",
		Instagram: "https://instagram.com/francispbaker",
	},
	Header: {
		Links: [
			{ name: "Blog", href: "/blog" },
			{ name: "Data", href: "/data" },
			{ name: "Projects", href: "/projects" },
			{ name: "Contributions", href: "/contributions" },
			{ name: "Resume", href: "/resume" },
			{ name: "Contact", href: "/contact" },
		],
	},
	ContactForm: {
		From: "noreply@francispbaker.com",
		To: "contact-form@francispbaker.com",
	},
};
